import React from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import BorrifacaoTab from '../components/BorrifacaoTab';
import '../components/Dashboard.css';

const BorrifacaoPage = () => {
    const navigate = useNavigate();
    const municipioId   = localStorage.getItem('user_municipio_id');
    const municipioNome = localStorage.getItem('user_municipio_nome') || '';

    React.useEffect(() => {
        if (!municipioId) navigate('/');
    }, [municipioId, navigate]);

    if (!municipioId) return null;

    return (
        <div className="portal-layout">
            <Header activeView="borrifacao" />
            <main className="main-content">
                <div className="content-container">
                    <div className="tab-header-container">
                        <div className="tab-title-group">
                            <h1 className="tab-title-main">Relatório de Borrifação</h1>
                            <p className="tab-subtitle-main">Registro e consulta dos resumos semanais de borrifação inseticida.</p>
                        </div>
                    </div>
                    <BorrifacaoTab municipioId={municipioId} municipioNome={municipioNome} />
                </div>
            </main>
        </div>
    );
};

export default BorrifacaoPage;
